import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers, ArrowRight, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { WordIcon } from "@/components/WordIcon";

export function DifficultWordsReview({ words }) {
  const [sel, setSel] = useState(() => new Set(words.map((w) => w.word)));
  const [busy, setBusy] = useState(false);
  const toggle = (w) => setSel((s) => { const n = new Set(s); n.has(w) ? n.delete(w) : n.add(w); return n; });

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/teams/reviews", { words: [...sel] });
      toast.success(`${data.count} mots envoyés en fiches à l'équipe`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  if (!words.length) return <p className="text-sm text-slate-600" data-testid="chef-difficult-empty">Aucun mot difficile pour le moment.</p>;
  return (
    <div className="space-y-2">
      {words.map((w, i) => (
        <label key={w.word} className="bg-white rounded-xl border-2 border-slate-200 p-3 flex items-center gap-3 cursor-pointer" data-testid={`chef-word-${i}`}>
          <Checkbox checked={sel.has(w.word)} onCheckedChange={() => toggle(w.word)} data-testid={`chef-word-check-${i}`} />
          <WordIcon word={w} size="sm" />
          <div className="flex-1 min-w-0">
            <div className="font-bold">{w.word}</div>
            <div className="text-xs text-slate-500 truncate">{w.members.join(", ")}</div>
          </div>
          <span className="font-display text-xl font-bold text-red-700">{w.members.length}</span>
        </label>
      ))}
      <button
        onClick={send}
        disabled={busy || !sel.size}
        data-testid="chef-review-send-btn"
        className="w-full h-12 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-bold flex items-center justify-center gap-2 transition-colors disabled:opacity-40"
      >
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />} Envoyer en fiches à l'équipe ({sel.size})
      </button>
    </div>
  );
}

export function TeamReviewCard() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/teams/reviews/latest").then((res) => setR(res.data)).catch(() => {}); }, []);
  if (!r || localStorage.getItem("btp_team_review_done") === r.id) return null;
  return (
    <Link to="/vocabulaire?equipe=1" data-testid="home-team-review-card" className="rise flex items-center gap-4 rounded-2xl bg-slate-900 text-white p-4 hover:bg-slate-800 transition-colors">
      <span className="w-12 h-12 rounded-xl bg-amber-400 text-slate-900 grid place-items-center"><Layers className="w-6 h-6" /></span>
      <span className="flex-1">
        <span className="block font-display text-2xl font-bold leading-none">Fiches du chef</span>
        <span className="block text-sm text-slate-300">{r.words.length} mots difficiles à réviser</span>
      </span>
      <ArrowRight className="w-6 h-6 text-amber-400" />
    </Link>
  );
}
